module.exports = __webpack_public_path__ + "img/way_d.e243daaa.jpg";